import { DashboardData, OrderDetails, TimeRange } from "../shared/types/dashboard";
import { filterValidOrders, parseNumber } from "./helpers";
import { calculatePopularItems } from "./popularItems";
import { calculatePaymentMethods } from "./paymentMethods";
import { getRecentOrders } from "./recentOrders";
import { generateTimeSeriesData } from "./timeSeries";

export const processOrderData = (
  orders: OrderDetails[],
  timeRange: TimeRange,
  customStartDate: string,
  customEndDate: string
): DashboardData => {

  const validOrders = filterValidOrders(orders);

  // 💵 Total Sales (overall)
  const totalSales = validOrders.reduce(
    (sum, order) =>
      sum +
      (parseNumber(order.Finalamount) ||
        parseNumber(order.totalAmount) ||
        order.totalAmount ||
        0),
    0
  );

  // 💰 Total Received Amount (from payments array)
  const receivedAmount = validOrders.reduce((total, order) => {
    const orderReceived = order.payments?.reduce(
      (sum, payment) => sum + (Number(payment.ReceivedAmount) || 0),
      0
    );
    return total + (orderReceived || 0);
  }, 0);

  // 🎁 Total Tip (separate field from backend)
const totalTip = validOrders.reduce((sum, order) => {
  const tipFromOrder = Number(order.Tip) || 0;

  const tipFromPayments =
    order.payments?.reduce(
      (s, p) => s + (Number((p as any).Tip) || 0),
      0
    ) || 0;

  return sum + tipFromOrder + tipFromPayments;
}, 0);

const totalDeliveryFee = validOrders.reduce((sum, order) => {
  return sum + (Number((order as any).deliveryFee) || 0);
}, 0);


  const totalOrders = validOrders.length;
  const averageOrderValue =
    totalOrders > 0 ? receivedAmount / totalOrders : 0;

  return {
    totalSales, // total (Subtotal + Tip + Discounts handled in backend)
    totalOrders,
    averageOrderValue,
    popularItems: calculatePopularItems(validOrders),
    paymentMethods: calculatePaymentMethods(validOrders),
    timeSeries: generateTimeSeriesData(
      validOrders,
      timeRange,
      customStartDate,
      customEndDate
    ),
    recentOrders: getRecentOrders(validOrders),
    receivedAmount,
    totalTip,
    totalDeliveryFee,
  };
};
